// extracted by mini-css-extract-plugin
export var change = "_3b-1";
export var changeList = "_3b-0";
export var changePath = "_3b-2";
export var diffArrow = "_3b-5";
export var diffRow = "_3b-3";
export var diffValue = "_3b-4";
export var error = "_3b-8";
export var notice = "_3b-9";
export var result = "_3b-6";
export var success = "_3b-7";